import type { ComputedRef, InjectionKey } from "vue";

export const FORM_FIELD_ID: InjectionKey<ComputedRef<string>> =
  Symbol("formFieldId");

/** Static boolean — always `true` when provided. Not a Ref. */
export const FORM_FIELD_WRAPPED: InjectionKey<boolean> =
  Symbol("formFieldWrapped");

export const FORM_FIELD_ARIA_DESCRIBEDBY: InjectionKey<
  ComputedRef<string | undefined>
> = Symbol("formFieldAriaDescribedby");

/** `true` when dirty + invalid, `undefined` otherwise (omits the attribute). */
export const FORM_FIELD_ARIA_INVALID: InjectionKey<
  ComputedRef<true | undefined>
> = Symbol("formFieldAriaInvalid");

/** `true` when required, `undefined` otherwise (omits the attribute). */
export const FORM_FIELD_ARIA_REQUIRED: InjectionKey<
  ComputedRef<true | undefined>
> = Symbol("formFieldAriaRequired");
